import { useNavigate } from "react-router-dom";
// src/pages/Finance.jsx вЂ” v8.7.6
//
// Р РµРґРёР·Р°Р№РЅ РїРѕ Р°РЅР°Р»РёР·Сѓ РєРѕР»Р»РµРіРё (Stripe/Datadog/Grafana РїР°С‚С‚РµСЂРЅС‹):
//
// 1. Р”РѕР±Р°РІР»РµРЅ РєРѕРЅС‚РµРєСЃС‚РЅС‹Р№ Р·Р°РіРѕР»РѕРІРѕРє "Finance Overview В· 30 Days"
// 2. KPI MetricBox: padding 20в†’14px, fontWeight 700в†’600, fontSize 28в†’22
//    ROI вЂ” РјРµРЅРµРµ РЅР°СЃС‹С‰РµРЅРЅС‹Р№ С†РІРµС‚ (РЅРµ РєСЂРёС‡Р°С‰РёР№)
// 3. Chart+Breakdown вЂ” РґРІСѓС…РєРѕР»РѕРЅРѕС‡РЅС‹Р№ layout (РєР°Рє РЅР° Dashboard)
//    Р»РµРІР°СЏ (1fr): FinanceChartV10 вЂ” РіР»Р°РІРЅС‹Р№
//    РїСЂР°РІР°СЏ (340px): DailyBreakdownV3 вЂ” РґРµС‚Р°Р»РёР·Р°С†РёСЏ
// 4. KPI СЃС‚СЂРѕРєР° РїРѕР»СѓС‡Р°РµС‚ border-bottom РєР°Рє СЂР°Р·РґРµР»РёС‚РµР»СЊ РѕС‚ РіСЂР°С„РёРєР°
// 5. Gap РјРµР¶РґСѓ Р±Р»РѕРєР°РјРё: 28в†’16px (РµРґРёРЅС‹Р№ СЂРёС‚Рј СЃ Dashboard)

import { useEffect, useState } from "react";
import { workerClient }        from "../api/workerClient";
import FinanceChartV10         from "../components/dashboard/FinanceChartV10";
import DailyBreakdownV3        from "../components/dashboard/DailyBreakdownV3";

// KPI РєР°СЂС‚РѕС‡РєР° вЂ” СЃРїРѕРєРѕР№РЅР°СЏ, РєРѕРЅС‚РµРєСЃС‚РЅР°СЏ, РЅРµ РєСЂРёС‡Р°С‰Р°СЏ
const KpiBox = ({ label, value, color, sub }) => (
  <div style={{
    flex: 1,
    padding: "14px 18px",
    background: "var(--bg-card)",
    border: "1px solid var(--border-subtle)",
    borderRadius: "var(--radius)",
    display: "flex", flexDirection: "column", gap: 6,
  }}>
    <div style={{
      fontFamily: "var(--font-mono)", fontSize: 9,
      letterSpacing: "0.14em", textTransform: "uppercase",
      color: "var(--text-muted)",
    }}>
      {label}
    </div>
    <div style={{
      fontFamily: "var(--font-mono)", fontSize: 22,
      fontWeight: 600,                             // Р±С‹Р»Рѕ 700 вЂ” С‡СѓС‚СЊ СЃРїРѕРєРѕР№РЅРµРµ
      color: color ?? "var(--text-primary)",
      lineHeight: 1, letterSpacing: "0.01em",
    }}>
      {value}
    </div>
    {sub && (
      <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--warning)" }}>
        {sub}
      </div>
    )}
  </div>
);

export default function Finance() {
  const navigate = useNavigate();
  const [today,      setToday]      = useState(null);
  const [isFallback, setIsFallback] = useState(false);
  const [trendData,  setTrendData]  = useState([]);
  const [breakdown,  setBreakdown]  = useState([]);
  const [loading,    setLoading]    = useState(true);

  useEffect(() => {
    Promise.all([
      workerClient("/api/finance"),
      workerClient("/api/finance/trends"),
      workerClient("/api/finance/daily"),
    ]).then(([fin, trends, daily]) => {
      const trendArr = Array.isArray(trends?.trend) ? trends.trend : [];
      if (trendArr.length) setTrendData(trendArr);
      if (Array.isArray(daily?.days)) setBreakdown(daily.days);

      const rawSpend   = Number(fin?.spend)   || 0;
      const rawRevenue = Number(fin?.revenue) || 0;

      if (fin?.ok && (rawSpend > 0 || rawRevenue > 0)) {
        setToday(fin); setIsFallback(false);
      } else if (trendArr.length > 0) {
        const last = [...trendArr]
          .filter(d => Number(d.spend) > 0 || Number(d.revenue) > 0).pop();
        if (last) {
          setToday({ ok:true, date:last.date, spend:Number(last.spend)||0, revenue:Number(last.revenue)||0, roi:Number(last.roi)||0 });
          setIsFallback(true);
        } else { setToday(fin); }
      } else { setToday(fin); }
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt  = v => `в‚¬ ${Number(v??0).toLocaleString("en-US")}`;
  const fmtR = v => { const p = Math.abs(v)<10 ? v*100:v; return (p>=0?"+":"")+p.toFixed(1)+"%"; };

  // ROI С†РІРµС‚ вЂ” РїСЂРёРіР»СѓС€С‘РЅРЅРµРµ С‡РµРј РЅР° Dashboard (РЅРµ РѕСЃРЅРѕРІРЅРѕР№ РіРµСЂРѕР№)
  const roiColor = v => {
    const p = Math.abs(v)<10 ? v*100:v;
    if (p>=20) return "rgba(16,217,126,0.85)";   // РїСЂРёРіР»СѓС€С‘РЅРЅС‹Р№ Р·РµР»С‘РЅС‹Р№
    if (p>=0)  return "rgba(245,166,35,0.85)";   // РїСЂРёРіР»СѓС€С‘РЅРЅС‹Р№ Р¶С‘Р»С‚С‹Р№
    return "rgba(240,64,64,0.85)";               // РїСЂРёРіР»СѓС€С‘РЅРЅС‹Р№ РєСЂР°СЃРЅС‹Р№
  };

  const fallbackNote = isFallback && today?.date ? `В· ${today.date} В· last available` : null;

  if (loading) {
    return (
      <div style={{ padding: 40, fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-muted)" }}>
        LoadingвЂ¦
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Return to Analyze */}
      <div data-no-print style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
        <button
          onClick={() => navigate("/analyze")}
          style={{
            fontFamily: "var(--font-mono)", fontSize: 10, cursor: "pointer",
            padding: "4px 10px", borderRadius: "var(--radius-sm)",
            background: "transparent", border: "1px solid var(--border-subtle)",
            color: "var(--text-muted)", display: "inline-flex", alignItems: "center", gap: 5,
          }}
        >
          ← Analyze
        </button>
      </div>

      {/* РљРѕРЅС‚РµРєСЃС‚РЅС‹Р№ Р·Р°РіРѕР»РѕРІРѕРє СЃС‚СЂР°РЅРёС†С‹ */}
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--text-secondary)" }}>
            Spend & Revenue Performance
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.1em", color: "var(--text-muted)", marginTop: 3 }}>
            30-day window В· last available
          </div>
        </div>
        {today?.date && (
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--text-muted)" }}>
            {today.date}{isFallback ? " В· last available" : ""}
          </span>
        )}
      </div>

      {/* KPI row вЂ” СЃРїРѕРєРѕР№РЅС‹Р№ РєРѕРЅС‚РµРєСЃС‚, РЅРµ РіР»Р°РІРЅС‹Р№ РіРµСЂРѕР№ */}
      <div style={{
        display: "flex", gap: 12,
        paddingBottom: 16,
        borderBottom: "1px solid var(--border-subtle)",
      }}>
        <KpiBox label="Revenue"  value={today ? fmt(today.revenue)   : "вЂ”"} color="var(--success)" sub={fallbackNote} />
        <KpiBox label="Spend"    value={today ? fmt(today.spend)     : "вЂ”"} color="var(--danger)" />
        <KpiBox label="ROI"      value={today ? fmtR(today.roi)      : "вЂ”"} color={today ? roiColor(today.roi) : "var(--text-muted)"} />
      </div>

      {/* Chart + Breakdown вЂ” РґРІСѓС…РєРѕР»РѕРЅРѕС‡РЅС‹Р№ layout */}
      {/* Р›РµРІР°СЏ (1fr): chart вЂ” РіР»Р°РІРЅС‹Р№, РїСЂР°РІР°СЏ (340px): С‚Р°Р±Р»РёС†Р° вЂ” РґРµС‚Р°Р»РёР·Р°С†РёСЏ */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 12, alignItems: "start" }}>
        <FinanceChartV10 data={trendData} />
        <DailyBreakdownV3 breakdown={breakdown} />
      </div>

    </div>
  );
}


